import {useNavigate} from 'react-router-dom'
import {useOktaStorage} from '@/hooks/useOktaStorage'
import {AvatarButton} from '@/components/atoms'
import {ROUTES} from '@/utils/constants/routesConstants'
import { useAuth } from '@/hooks/useAuth'
import { Avatar } from 'pepsico-ds'

/**
 * A button component that displays a user avatar with the user's name and handles navigation on click
 * @param {Object} props - The component props
 * @returns {JSX.Element} UserAvatarButton component
 */
export function UserAvatarButton() {
  const navigate = useNavigate()
  
  const {claims, accessToken} = useAuth()
  const {firstName, lastName} = claims

  const fullName = !!firstName && !!lastName ? `${firstName} ${lastName}` : ''

  return <Avatar 
          name={fullName} 
          onClick={() => navigate(ROUTES.LOGOUT)} 
          className="h-8 w-8" 
          type="text"
          size="small"
          testId="header-user-avatar" 
        />
}
